import Ajv from 'ajv/dist/2020';
import addFormats from 'ajv-formats';
import localize_ajv_en from 'ajv-i18n/localize/en';
import localize_ajv_br from 'ajv-i18n/localize/pt-BR';

const LOCALIZE_AJV_MAP = {
  'en-US': localize_ajv_en,
  'pt-BR': localize_ajv_br,
};

// Function that formats the error message with the respective params into a single string
// e.g. Error in /: must NOT have additional properties (additionalProperty: definition)
const formatAjvErrorMessage = error => {
  if (!error) return '';

  const baseMessage = error.message || '';

  const { params } = error;
  if (params && Object.keys(params).length > 0) {
    const formattedParams = Object.entries(params)
      .map(([key, value]) => `${key}: ${value}`)
      .join(', ');
    return `${baseMessage} (${formattedParams})`;
  }

  return baseMessage;
};

const filterRelevantErrors = errors => {
  return errors.filter(e => {
    if (['if', 'then', 'allOf'].includes(e.keyword)) return false;

    if (
      e.keyword === 'unevaluatedProperties' &&
      this.errors.filter(e2 => e2.instancePath === e.instancePath).length > 1
    )
      return false;

    return true;
  });
};

export const createJsonValidator = ({ schema }) => {
  const ajv = new Ajv({
    strict: false,
    allErrors: true,
    messages: false,
    $data: true,
    $comment: true,
    logger: false,
  });
  addFormats(ajv);

  const localize = (language, errors) => LOCALIZE_AJV_MAP[language](errors);
  const parse = data => JSON.parse(data);
  const validate = ajv.compile(schema);
  validate.formatErrors = function formatErrors() {
    if (!this.errors) return [];
    return filterRelevantErrors(this.errors).map(e => ({
      ...e,
      message: formatAjvErrorMessage(e),
    }));
  };

  return { localize, parse, validate };
};
